export default __webpack_public_path__ + "static/media/partner-jambo.b06d4e33.png";